<template>
  <div>
    <!-- Phone Input -->
    <div class="col form-group">
      <input
        v-if="!obj.passport"
        ref="phoneInput"
        id="phone"
        v-model="obj.phone"
        v-mask="'(##) #####-####'"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="$t('phone.mobile')"
        type="tel"
        @keyup.enter="validateFields"
      />

      <!-- Phone Estrangeiro -->
      <div v-else class="phoneNumber">
        <div>
          <input
            list="countries"
            class="c-input inputWidth"
            :placeholder="$t('phone.ddi')"
            id="phoneCodeInput"
            v-model="selectedPhoneCode"
            @keyup.enter="validateFields"
          />
          <datalist id="countries">
            <option
              class="text-black"
              v-for="(i, index) in countries"
              :value="'+' + i.phone_Code"
              :key="index"
            >
              {{ i.country_Name }}
            </option>
          </datalist>
        </div>
        <input
          v-model="areaCode"
          class="inputWidth"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="$t('phone.areaCode')"
          @keyup.enter="validateFields"
        />
        <input
          v-model="phoneNumber"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="$t('phone.yourPhone')"
          @keyup.enter="validateFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'

export default {
  name: 'Phone',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: {
      Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    selectedPhoneCode: '',
    phoneNumber: '',
    areaCode: '',
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template', 'countries']),
    phone() {
      return `${this.selectedPhoneCode} ${this.areaCode} ${this.phoneNumber}`
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
  },
  methods: {
    ...mapMutations([
      'addRegistrationError',
      'clearRegistrationErrors',
      'updateRegistrationObject',
    ]),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.$t('common.attention'),
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.phone) {
        const warningMsg = this.obj.passport
          ? 'It is necessary to provide a telephone number.'
          : 'É necessário informar um telefone.'
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')
        hasErrors = true
      }

      if (!this.obj.passport) {
        if (!this.validatePhone(this.obj.phone)) {
          const warningMsg = 'Informe um telefone válido.'
          this.addRegistrationError({
            msg: warningMsg,
          })
          this.toastMessage = warningMsg
          this.makeToast('warning')

          hasErrors = true
        }
      } else {
        if (!this.validateInternationalPhone(this.obj.phone)) {
          const warningMsg = 'Please provide a valid international telephone number.'
          this.addRegistrationError({
            msg: warningMsg,
          })
          this.toastMessage = warningMsg
          this.makeToast('warning')
          hasErrors = true
        }
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
    validatePhone(phone) {
      return phone.length === 15
    },
    validateInternationalPhone(phone) {
      var regex = /^[+]{1}(?:[0-9\-\\(\\)\\/.]\s?){6,15}[0-9]{1}$/
      return regex.test(phone)
    },
  },
  watch: {
    phone(newPhone) {
      this.obj.phone = newPhone
    },
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
}
</script>

<style>
.phoneNumber {
  display: flex;
  gap: 20px;
}

.inputWidth {
  width: 70px;
}
</style>
